import { observer } from "mobx-react-lite";
import type { ComponentProps } from "react";

import { productImageUrl } from "../../../common/imageUtils";
import type { ProductBasics } from "../../../common/types/productTypes";

interface ProductImageProps extends ComponentProps<"img"> {
   product: ProductBasics;
   size: number;
}

const ProductImage = ({ product, size, ...rest }: ProductImageProps) => {
   return (
      <img
         loading="lazy"
         width={size}
         src={productImageUrl(product.sku, size)}
         {...rest}
         alt={`Produktbilde av ${product.name}`}
      />
   );
};

export default observer(ProductImage);
